import {
  BACK,
  CERCA,
  BACK_HOME,
  APRI,
  CHIUDI,
  NO_DATA,
  CLEAR,
  YES_LABEL,
  NO_LABEL,
  INFO_LABEL,
  HOME_LABEL,
  WELCOME_TITLE,
  WELCOME_INFO,
  WELCOME_INFO_2,
  WELCOME_INFO_3,
  NEXT,
  ENTER,
  INSTALLATION_DRAWER_SUBHEADER,
  INSTALLATION_DRAWER_INFO,
  INSTALLATION_DRAWER_SHARE_INSTRUCTIONS,
  INSTALLATION_DRAWER_SHARE_LABEL,
  INSTALLATION_DRAWER_ADD_TO_HOME_INSTRUCTIONS,
  INSTALLATION_DRAWER_ADD_TO_DOCK_INSTRUCTIONS,
  INSTALLATION_DRAWER_ADD_TO_HOME_LABEL,
  INSTALLATION_DRAWER_ADD_TO_DOCK_LABEL,
  HOME_INFO,
  PRONTO_SOCCORSO_PLACEHOLDER,
  CODICE_ACCESSO_PLACEHOLDER,
  REQUIRED_FIELD,
  CODICE_ACCESSO_ERROR,
  CODICE_ACCESSO_ERROR_2,
  CODICE_ACCESSO_EXPIRED,
  CODICE_ACCESSO_EXPIRED_DESCRIPTION,
  INSTALLA_APP_REQUEST,
  INSTALLA_APP_INFO,
  INSTALLA_APP_BUTTON,
  NOTIFICHE_NEGATE_ALERT,
  NOTIFICATION_ACTIVE,
  NOTIFICATION_ACTIVE_ARIA_LABEL,
  NOTIFICATION_UNACTIVE,
  NOTIFICATION_UNACTIVE_ARIA_LABEL,
  ENCOUNTER_OSPEDALE_CHANGED,
  ENCOUNTER_LUOGO_CHANGED,
  ENCOUNTER_STATO_CHANGED,
  ENCOUNTER_COLORE_CHANGED,
  ENCOUNTER_PRESTAZIONI_CHANGED,
  MESSAGGIO_RASSICURANTE,
  LAST_UPDATE,
  UPDATE_PRESTAZIONE,
  GOOGLE_MAPS_MODAL,
  NAVIGA,
  CODICE_EMERGENZA,
  CODICE_EMERGENZA_BIANCO,
  CODICE_EMERGENZA_VERDE,
  CODICE_EMERGENZA_AZZURRO,
  CODICE_EMERGENZA_ARANCIONE,
  CODICE_EMERGENZA_ROSSO,
  STATO_PAZIENTE,
  PRONTO_SOCCORSO,
  ACCESSO_PS,
  POSIZIONE,
  PRESTAZIONI_LABEL,
  EMPTY_MESSAGE,
  EVENT_COMPLETED_LABEL,
  FOLLOW_UP_REQUEST,
  FOOTER_PRIVACY_POLICY,
  FOOTER_COOKIE_POLICY,
  FOOTER_ACCESSIBILITA,
  FOOTER_COLORI_TRIAGE,
  FOOTER_FAQ,
  FOOTER_CONTATTI,
  LOADING_CONFIG_ERROR,
  LOADING_PS_ERROR,
  RETRY,
  NOT_FOUND_ERROR,
  NOT_FOUND_TITLE,
  NOT_FOUND_DESCRIPTION,
  SAGAS_CONFIG_ERROR_TITLE,
  SAGAS_CONFIG_ERROR_DESCRIPTION,
  SAGAS_ELENCO_OSPEDALI_ERROR_TITLE,
  SAGAS_ELENCO_OSPEDALI_ERROR_DESCRIPTION,
  SAGAS_CODICI_COLORE_ERROR_TITLE,
  SAGAS_CODICI_COLORE_ERROR_DESCRIPTION,
  SAGAS_FAQ_ERROR_TITLE,
  SAGAS_FAQ_ERROR_DESCRIPTION,
  SAGAS_COOKIE_POLICY_ERROR_TITLE,
  SAGAS_COOKIE_POLICY_ERROR_DESCRIPTION,
  SAGAS_CONTACTS_ERROR_TITLE,
  SAGAS_CONTACTS_ERROR_DESCRIPTION,
  SAGAS_PRIVACY_PS_ERROR_TITLE,
  SAGAS_PRIVACY_PS_ERROR_DESCRIPTION,
  SAGAS_INIZIO_MONITORAGGIO_ERROR_TITLE,
  SAGAS_INIZIO_MONITORAGGIO_ERROR_DESCRIPTION,
  SAGAS_SERVER_ERROR_TITLE,
  SAGAS_SERVER_ERROR_DESCRIPTION,
  TOO_MANY_REQUEST_ERROR_TITLE,
  TOO_MANY_REQUEST_ERROR_DESCRIPTION,
  SAGAS_CHECK_SUBSCRIPTION_ERROR_TITLE,
  SAGAS_CHECK_SUBSCRIPTION_ERROR_DESCRIPTION,
  SAGAS_SUBSCRIPTION_ERROR_TITLE,
  SAGAS_SUBSCRIPTION_ERROR_DESCRIPTION,
  SAGAS_UNSUBSCRIPTION_ERROR_TITLE,
  SAGAS_UNSUBSCRIPTION_ERROR_DESCRIPTION,
} from "./labels";

export const it = {
  // Label common
  [BACK]: "Indietro",
  [CERCA]: "Cerca",
  [BACK_HOME]: "Torna alla home",
  [APRI]: "Apri",
  [CHIUDI]: "Chiudi",
  [NO_DATA]: "Nessun risultato",
  [CLEAR]: "Cancella",
  [YES_LABEL]: "Sì",
  [NO_LABEL]: "No",
  [INFO_LABEL]: "Info",
  [HOME_LABEL]: "Home",

  // Label welcome page
  [WELCOME_TITLE]: "Benvenuto in PS TRACKER",
  [WELCOME_INFO]: "PS Tracker è il sistema digitale che ti permette di seguire in tempo reale il percorso di un familiare o un amico per tutta la durata della sua permanenza in pronto soccorso (per maggiori dettagli consultare le ", // prettier-ignore
  [WELCOME_INFO_2]: "Clicca su Entra e inserisci il codice che hai ricevuto dal paziente per avere aggiornamenti e notifiche sul codice di priorità che gli è stato assegnato, sul tipo di prestazione che sta ricevendo e sull’area del pronto soccorso in cui si trova.", // prettier-ignore
  [WELCOME_INFO_3]: "Attenzione, questo sistema ha un valore puramente informativo e le informazioni che vengono trasmesse non hanno pertanto il valore legale che ha il solo verbale di pronto soccorso che viene consegnato alla dimissione.", // prettier-ignore
  [NEXT]: "Avanti",
  [ENTER]: "Entra",

  // Label per il drawer installazione iOS
  [INSTALLATION_DRAWER_SUBHEADER]: "Applicazione che permette il monitoraggio in tempo reale di un paziente al pronto soccorso",
  [INSTALLATION_DRAWER_INFO]: "Per installare l'applicazione da {browser} su {device}:",
  [INSTALLATION_DRAWER_SHARE_INSTRUCTIONS]: "1. Premi il pulsante ",
  [INSTALLATION_DRAWER_SHARE_LABEL]: "Condividi",
  [INSTALLATION_DRAWER_ADD_TO_HOME_INSTRUCTIONS]: "2. Scorri verso l'alto e premi il pulsante ",
  [INSTALLATION_DRAWER_ADD_TO_DOCK_INSTRUCTIONS]: "2. Premi il pulsante ",
  [INSTALLATION_DRAWER_ADD_TO_HOME_LABEL]: "Aggiungi alla schermata Home",
  [INSTALLATION_DRAWER_ADD_TO_DOCK_LABEL]: "Aggiungi al Dock",

  // Label per la pagina home
  [HOME_INFO]: "Inserisci il codice d’accesso consegnato al paziente in pronto soccorso",
  [PRONTO_SOCCORSO_PLACEHOLDER]: "Pronto Soccorso",
  [CODICE_ACCESSO_PLACEHOLDER]: "Codice accesso (es. X012345)",
  [REQUIRED_FIELD]: "Campo obbligatorio",
  [CODICE_ACCESSO_ERROR]: "Il codice accesso deve essere di ",
  [CODICE_ACCESSO_ERROR_2]: "cifre",
  [CODICE_ACCESSO_EXPIRED]: "Codice accesso inesistente o non più valido",
  [CODICE_ACCESSO_EXPIRED_DESCRIPTION]: "Il codice accesso inserito potrebbe essere inesistente o non più valido",
  [INSTALLA_APP_REQUEST]: "Vuoi installare l'applicazione PSTracker?",
  [INSTALLA_APP_INFO]: "Per un'esperienza migliore è consigliata l'installazione della app",
  [INSTALLA_APP_BUTTON]: "Istruzioni",
  [NOTIFICHE_NEGATE_ALERT]: "Non hai acconsentito alle notifiche o stai navigando in incognito e di conseguenza non potrai ricevere notifiche di aggiornamento", // prettier-ignore

  // Label per la pagina di monitoraggio
  [NOTIFICATION_ACTIVE]: "Attive",
  [NOTIFICATION_ACTIVE_ARIA_LABEL]: "Notifiche attive",
  [NOTIFICATION_UNACTIVE]: "Non attive",
  [NOTIFICATION_UNACTIVE_ARIA_LABEL]: "Notifiche non attive",
  [ENCOUNTER_OSPEDALE_CHANGED]: "Variazione nel pronto soccorso",
  [ENCOUNTER_LUOGO_CHANGED]: "Variazione nell'Area",
  [ENCOUNTER_STATO_CHANGED]: "Variazioni nello Stato",
  [ENCOUNTER_COLORE_CHANGED]: "Variazione nel Codice di priorità",
  [ENCOUNTER_PRESTAZIONI_CHANGED]: "Variazione nelle Prestazioni",
  [MESSAGGIO_RASSICURANTE]: "Nessun nuovo aggiornamento",
  [LAST_UPDATE]: "Ultimo aggiornamento: ",
  [UPDATE_PRESTAZIONE]: "Prestazione aggiornata",
  [GOOGLE_MAPS_MODAL]: "L'applicazione desidera aprire Google Maps, continuare?",
  [NAVIGA]: "Vai al percorso",
  [CODICE_EMERGENZA]: "Codice di priorità:",
  [CODICE_EMERGENZA_BIANCO]: "Bianco",
  [CODICE_EMERGENZA_VERDE]: "Verde",
  [CODICE_EMERGENZA_AZZURRO]: "Azzurro",
  [CODICE_EMERGENZA_ARANCIONE]: "Arancione",
  [CODICE_EMERGENZA_ROSSO]: "Rosso",
  [STATO_PAZIENTE]: "Stato",
  "ld.monitoraggio.stato.undefined": "-",
  "ld.monitoraggio.stato.finished": "-",
  "ld.monitoraggio.stato.onleave": "-",
  "ld.monitoraggio.stato.arrived": "-",
  "ld.monitoraggio.stato.triaged": "In attesa di valutazione medica",
  "ld.monitoraggio.stato.in-progress": "Presa in carico",
  "ld.monitoraggio.stato.cancelled": "Cancellato",
  "ld.monitoraggio.stato.wait-admission": "Valutazione paziente per definizione ricovero",
  "ld.monitoraggio.stato.admitting-at": "Ricoverato",
  "ld.monitoraggio.stato.leave-before-visit": "Abbandono spontaneo prima della visita medica",
  "ld.monitoraggio.stato.leave-after-visit": "Abbandono spontaneo dopo visita medica",
  "ld.monitoraggio.stato.discharging": "In corso di dimissione",
  "ld.monitoraggio.stato.discharged": "Dimesso",
  "ld.monitoraggio.stato.obi": "Reparto di Osservazione (OBI)",
  "ld.monitoraggio.stato.refuses-admission": "Rifiuta ricovero",
  [PRONTO_SOCCORSO]: "Pronto Soccorso:",
  [ACCESSO_PS]: "Accesso:",
  [POSIZIONE]: "Area:",
  "ld.monitoraggio.dialog.contact-staff": "Per ulteriori informazioni, rivolgersi al personale sanitario (0105554787 - 3333751019)",
  "ld.monitoraggio.dialog.contact-staff-transferred": "Paziente in corso di trasferimento, rivolgersi al personale sanitario (0105554787 - 3333751019)", // prettier-ignore
  "ld.monitoraggio.messaggio.finished": "Evento di pronto soccorso terminato il {endDate} alle {endTime}. Non seguiranno ulteriori aggiornamenti. L'episodio sarà consultabile fino al {dischargeInfoDate} alle {dischargeInfoTime}", // prettier-ignore
  [PRESTAZIONI_LABEL]: "Prestazioni",
  "ld.monitoraggio.prestazioni.s-blood": "Esami di laboratorio n.{order}",
  "ld.monitoraggio.prestazioni.s-imaging": "Diagnostica n.{order}",
  "ld.monitoraggio.prestazioni.s-consultations": "Visite specialistiche n.{order}",
  "ld.monitoraggio.prestazioni.l-evaluation": "In corso di valutazione medica",
  "ld.monitoraggio.prestazioni.l-reassessment": "Effettuata valutazione stato del paziente n.{order}",
  "ld.monitoraggio.prestazioni.l-nursing": "Assistenza al paziente n.{order}",
  "ld.monitoraggio.prestazioni.l-ward": "Assistenza al paziente n.{order}",
  "ld.monitoraggio.prestazioni.l-diary": "Effettuata valutazione stato del paziente n.{order}",
  "ld.monitoraggio.prestazioni.stato.draft": "Ordinato",
  "ld.monitoraggio.prestazioni.stato.active": "In corso",
  "ld.monitoraggio.prestazioni.stato.completed": "Refertato",
  "ld.monitoraggio.prestazioni.stato.executed": "Eseguito",
  "ld.monitoraggio.prestazioni.stato.revoked": "Annullato",
  [EMPTY_MESSAGE]: "Nessuna prestazione sanitaria ordinata al momento",
  [EVENT_COMPLETED_LABEL]: "L'evento di pronto soccorso che stavi monitorando è terminato",
  [FOLLOW_UP_REQUEST]: "Vuoi ricevere aggiornamenti in tempo reale per questo episodio di pronto soccorso?",

  // Label per il footer
  [FOOTER_PRIVACY_POLICY]: "Privacy Policy",
  [FOOTER_COOKIE_POLICY]: "Cookie Policy",
  [FOOTER_ACCESSIBILITA]: "Dichiarazione di accessibilità",
  [FOOTER_COLORI_TRIAGE]: "Legenda codici priorità",
  [FOOTER_FAQ]: "Faq",
  [FOOTER_CONTATTI]: "Contatti e assistenza",

  // Label per la pagina di errore
  [LOADING_CONFIG_ERROR]: "Caricamento configurazione fallito",
  [LOADING_PS_ERROR]: "Caricamento elenco pronto soccorso fallito",
  [RETRY]: "Riprova",

  // Label per la pagina not found
  [NOT_FOUND_ERROR]: "Errore",
  [NOT_FOUND_TITLE]: "404",
  [NOT_FOUND_DESCRIPTION]: "La pagina richiesta non esiste",

  // Label per i sagas
  [SAGAS_CONFIG_ERROR_TITLE]: "Errore durante il recupero delle configurazioni applicative",
  [SAGAS_CONFIG_ERROR_DESCRIPTION]: "Si è verificato un errore durante il recupero delle configurazioni applicative",
  [SAGAS_ELENCO_OSPEDALI_ERROR_TITLE]: "Errore durante il recupero dell'elenco dei pronto soccorso",
  [SAGAS_ELENCO_OSPEDALI_ERROR_DESCRIPTION]: "Si è verificato un errore durante il recupero dell'elenco dei pronto soccorso",
  [SAGAS_CODICI_COLORE_ERROR_TITLE]: "Errore durante il recupero dei codici colore",
  [SAGAS_CODICI_COLORE_ERROR_DESCRIPTION]: "Si è verificato un errore durante il recupero dei codici colore",
  [SAGAS_FAQ_ERROR_TITLE]: "Errore durante il recupero delle FAQ",
  [SAGAS_FAQ_ERROR_DESCRIPTION]: "Si è verificato un errore durante il recupero delle FAQ",
  [SAGAS_COOKIE_POLICY_ERROR_TITLE]: "Errore durante il recupero delle Cookie Policy",
  [SAGAS_COOKIE_POLICY_ERROR_DESCRIPTION]: "Si è verificato un errore durante il recupero delle Cookie Policy",
  [SAGAS_CONTACTS_ERROR_TITLE]: "Errore durante il recupero dei contatti",
  [SAGAS_CONTACTS_ERROR_DESCRIPTION]: "Si è verificato un errore durante il recupero dei contatti",
  [SAGAS_PRIVACY_PS_ERROR_TITLE]: "Errore durante il recupero delle privacy policy per il pronto soccorso",
  [SAGAS_PRIVACY_PS_ERROR_DESCRIPTION]: "lSi è verificato un errore durante il recupero delle privacy policy per il pronto soccorso",
  [SAGAS_INIZIO_MONITORAGGIO_ERROR_TITLE]: "Errore durante il recupero delle informazioni di monitoraggio",
  [SAGAS_INIZIO_MONITORAGGIO_ERROR_DESCRIPTION]: "Si è verificato un errore durante il recupero delle informazioni di monitoraggio",
  [SAGAS_SERVER_ERROR_TITLE]: "Recupero delle informazioni",
  [SAGAS_SERVER_ERROR_DESCRIPTION]: "Si è verificato un problema nel recupero delle informazioni. Ti preghiamo di riprovare più tardi. Grazie per la comprensione", // prettier-ignore
  [TOO_MANY_REQUEST_ERROR_TITLE]: "Recupero delle informazioni. Numero di richieste troppo elevato",
  [TOO_MANY_REQUEST_ERROR_DESCRIPTION]: "Stiamo elaborando un numero elevato di richieste. Per favore, attendi qualche momento prima di riprovare. Grazie per la tua comprensione", // prettier-ignore
  [SAGAS_CHECK_SUBSCRIPTION_ERROR_TITLE]: "Errore durante il recupero degli eventi di pronto soccorso associati",
  [SAGAS_CHECK_SUBSCRIPTION_ERROR_DESCRIPTION]: "Si è verificato un errore durante il recupero degli eventi di pronto soccorso associati",
  [SAGAS_SUBSCRIPTION_ERROR_TITLE]: "Errore durante la sottoscrizione dell'evento di pronto soccorso",
  [SAGAS_SUBSCRIPTION_ERROR_DESCRIPTION]: "Si è verificato un errore durante la sottoscrizione dell'evento di pronto soccorso",
  [SAGAS_UNSUBSCRIPTION_ERROR_TITLE]: "Errore durante la dissociazione dell'evento di pronto soccorso",
  [SAGAS_UNSUBSCRIPTION_ERROR_DESCRIPTION]: "Si è verificato un errore durante la dissociazione dell'evento di pronto soccorso",
};
